import { AppBar, Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLORS } from 'src/react/_Layout/StyleConstants';
import { modalDialogCloseButtonZIndex } from 'src/utils/zIndexConstants';

export const StyledAppBar = styled(AppBar)({
  backgroundColor: 'white',
  color: COLORS.greyText,
  borderBottom: `1px solid ${COLORS.greyText}`,
});

export const AppBarTitle = styled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: 1,
});

export const CloseLabel = styled(AppBarTitle)({ width: '100%', cursor: 'pointer' });

export const DialogContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<{ backgroundColor?: string }>(({ backgroundColor }) => ({
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  position: 'absolute',
  top: 48,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor,
}));

export const FloatingCloseButton = styled(IconButton)({
  left: 0,
  position: 'absolute',
  color: 'gray',
  mixBlendMode: 'difference',
  zIndex: modalDialogCloseButtonZIndex,
});

export const SecondaryActionArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: theme.spacing(6),
}));

export const SecondaryActionLabel = styled(Box)(({ theme }) => ({ paddingRight: theme.spacing(2) }));
